import type { RefOrGetter } from "ls/common/types";
import { useIsModPressed } from "ls/composables/useIsModPressed";
import { toValue } from "vue";

export function useLinkNodeClick(readonly: RefOrGetter<boolean>) {
  const isModPressed = useIsModPressed();

  function handleLinkClick(event: MouseEvent) {
    // let links work as usual in the case when the text editor is in readonly mode
    if (toValue(readonly)) return;

    // prevent default link behavior when Meta or Control not pressed
    // toggle toolbar instead
    if (!isModPressed.value) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.stopPropagation();
    }
  }

  return {
    isPointer: isModPressed,
    handleLinkClick,
  };
}
